import { takeLatest, put, call } from 'redux-saga/effects';
import { filterFuncionarioCadastro } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO,
  NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_PENDING,
  NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { CONST_FILTER_FUNCIONARIO_CADASTRO } from '@commons/consts';

function* sagaNewFilterNextPageFuncionarioCadastro(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_PENDING });
  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada
      .id;
    let filterSaved =
      sessionStorage.getItem(CONST_FILTER_FUNCIONARIO_CADASTRO) !== null
        ? JSON.parse(
            sessionStorage.getItem(CONST_FILTER_FUNCIONARIO_CADASTRO),
          )
        : null;

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(
      filterFuncionarioCadastro,
      idFazenda,
      `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`,
    );
    sessionStorage.setItem(
      CONST_FILTER_FUNCIONARIO_CADASTRO,
      JSON.stringify(newFilter),
    );

    yield put({
      type: NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_SUCCESS,
      list: list,
      filter: newFilter,
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_FAILURE });
  }
}

export default function* watchNewFilterNextPageFuncionarioCadastro() {
  yield takeLatest(
    NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO,
    sagaNewFilterNextPageFuncionarioCadastro,
  );
}